import React from 'react'
import { Route } from 'react-router-dom'
import NotificationsConfigurations from '../../../../components/Notifications/NotificationView'

const NotificationsConfigurationsRoutes = ({ match }) => (
  <div>
    <Route path={match.path} component={NotificationsConfigurations} />
  </div>
)

export default NotificationsConfigurationsRoutes